import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import rootReducer from './reducers';

const persistConfig = {
    key: 'root',
    storage,
    // Шторка меню сюда не входит: она чинится одним кликом, а сохранённая переживала
    // перезагрузку и на телефоне могла открыть приложение с меню поверх страницы.
    whitelist: ['auth', 'profile', 'deck', 'practice'],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

// configureStore вместо createStore: thunk и инструменты разработчика включены сами.
// Проверка сериализуемости остаётся, но не ругается на служебные действия
// redux-persist — они несут несериализуемые поля по замыслу самой библиотеки.
const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
        serializableCheck: {
            ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
        },
    }),
});

export const persistor = persistStore(store);
export default store;
